/**
 * Browser Detection Utility
 * تشخیص مرورگر و مدیریت ریدایرکت
 */

// Detect Instagram Browser
export const isInstagramBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Instagram/i.test(userAgent);
};

// Detect Facebook Browser
export const isFacebookBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /FBAN|FBAV/i.test(userAgent);
};

// Detect WhatsApp Browser
export const isWhatsAppBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /WhatsApp/i.test(userAgent);
};

// Detect Telegram Browser
export const isTelegramBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Telegram/i.test(userAgent);
};

// Detect In-App Browser
export const isInAppBrowser = () => {
  return isInstagramBrowser() || isFacebookBrowser() || isWhatsAppBrowser() || isTelegramBrowser();
};

// Check Camera Support
export const hasCameraSupport = () => {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
};

// Test camera access
export const testCameraAccess = async () => {
  try {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      return false;
    }
    
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    stream.getTracks().forEach(track => track.stop());
    return true;
  } catch (error) {
    console.log('Camera access test failed:', error);
    return false;
  }
};

// Redirect to External Browser
export const redirectToExternalBrowser = () => {
  const redirectUrl = `https://dermowise.web.app${window.location.pathname}${window.location.search}`;
  
  console.log('Attempting to redirect to default browser:', redirectUrl);
  
  // Try multiple methods to redirect to default browser
  try {
    // Method 1: Direct redirect (works in most cases)
    window.location.href = redirectUrl;
    console.log('Redirect attempted via window.location.href');
    return;
  } catch (e) {
    console.log('window.location.href failed:', e);
  }
  
  try {
    // Method 2: Replace current page
    window.location.replace(redirectUrl);
    console.log('Redirect attempted via window.location.replace');
    return;
  } catch (e) {
    console.log('window.location.replace failed:', e);
  }
  
  try {
    // Method 3: Open in new tab
    const newWindow = window.open(redirectUrl, '_blank');
    if (newWindow) {
      newWindow.focus();
      console.log('Redirect successful via window.open');
      return;
    }
  } catch (e) {
    console.log('window.open failed:', e);
  }
  
  try {
    // Method 4: Create a link and click it
    const link = document.createElement('a');
    link.href = redirectUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.log('Redirect attempted via link click');
    return;
  } catch (e) {
    console.log('Link click failed:', e);
  }
  
  // Method 5: Show alert with manual instruction (fallback)
  alert('برای استفاده از دوربین، لطفاً لینک زیر را در مرورگر اصلی گوشی باز کنید:\n\n' + redirectUrl);
};

// Show Browser Warning Modal
export const showBrowserWarning = () => {
  if (isInAppBrowser()) {
    // eslint-disable-next-line no-restricted-globals
    const shouldRedirect = confirm(
      '⚠️ مشکل دسترسی به دوربین\n\n' +
      'شما در حال حاضر در مرورگر اینستاگرام/فیس‌بوک هستید.\n' +
      'برای استفاده از دوربین، باید در مرورگر اصلی گوشی باز کنید.\n\n' +
      'آیا می‌خواهید به مرورگر اصلی هدایت شوید؟'
    );
    
    if (shouldRedirect) {
      redirectToExternalBrowser();
      return true;
    } else {
      // Show manual instruction
      alert(
        'برای استفاده از دوربین:\n\n' +
        '1. روی سه نقطه (⋯) در بالای صفحه کلیک کنید\n' +
        '2. "Open in Browser" یا "باز کردن در مرورگر" را انتخاب کنید\n' +
        '3. یا لینک زیر را کپی کرده و در مرورگر اصلی باز کنید:\n\n' +
        window.location.href
      );
    }
  }
  return false;
};

// Debug function to log browser info
export const debugBrowserInfo = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  console.log('User Agent:', userAgent);
  console.log('Is Instagram:', isInstagramBrowser());
  console.log('Is Facebook:', isFacebookBrowser());
  console.log('Is WhatsApp:', isWhatsAppBrowser());
  console.log('Is Telegram:', isTelegramBrowser());
  console.log('Is In-App Browser:', isInAppBrowser());
  console.log('Has Camera Support:', hasCameraSupport());
};

// Immediate redirect for in-app browsers
export const immediateRedirect = () => {
  if (isInAppBrowser()) {
    const redirectUrl = `https://dermowise.web.app${window.location.pathname}${window.location.search}`;
    
    console.log('Instagram browser detected, redirecting to:', redirectUrl);
    
    // Method 1: Try to open in external browser using window.open
    // This is the most reliable method for Instagram in-app browser
    try {
      const newWindow = window.open(redirectUrl, '_blank');
      if (newWindow) {
        newWindow.focus();
        console.log('Successfully opened in external browser');
        return true;
      }
    } catch (e) {
      console.log('window.open failed:', e);
    }
    
    // Method 2: Try direct location change
    try {
      window.location.href = redirectUrl;
      console.log('Redirected via window.location.href');
      return true;
    } catch (e) {
      console.log('window.location.href failed:', e);
    }
    
    // Method 3: Try location replace
    try {
      window.location.replace(redirectUrl);
      console.log('Redirected via window.location.replace');
      return true;
    } catch (e) {
      console.log('window.location.replace failed:', e);
    }
    
    // Method 4: Create invisible link and click it
    try {
      const link = document.createElement('a');
      link.href = redirectUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log('Redirected via link click');
      return true;
    } catch (e) {
      console.log('Link click failed:', e);
    }
    
    // Method 5: Show user instruction (fallback)
    alert('لطفاً برای استفاده از دوربین، این لینک را در مرورگر اصلی گوشی باز کنید:\n\n' + redirectUrl);
    return true;
  }
  return false;
};

// Check and Handle Browser Issues with user permission
export const handleBrowserCompatibility = () => {
  // Debug info
  debugBrowserInfo();
  
  if (isInAppBrowser()) {
    // Ask user permission first
    // eslint-disable-next-line no-restricted-globals
    const shouldRedirect = confirm(
      'برای استفاده از دوربین، باید در مرورگر اصلی گوشی باز کنید.\n\n' +
      'آیا می‌خواهید به مرورگر اصلی هدایت شوید؟'
    );
    
    if (shouldRedirect) {
      return immediateRedirect();
    } else {
      // Show manual instruction
      alert(
        'برای استفاده از دوربین:\n\n' +
        '1. روی سه نقطه (⋯) در بالای صفحه کلیک کنید\n' +
        '2. "Open in Browser" یا "باز کردن در مرورگر" را انتخاب کنید\n' +
        '3. یا لینک زیر را کپی کرده و در مرورگر اصلی باز کنید:\n\n' +
        window.location.href
      );
    }
  }
  return false;
};

// Direct redirect without asking (for automatic redirect)
export const handleBrowserCompatibilityDirect = () => {
  // Debug info
  debugBrowserInfo();
  
  if (isInAppBrowser()) {
    // Direct redirect without asking
    return immediateRedirect();
  }
  return false;
};
